import React from 'react';
import TopNavigation from '../../sections/TopNavigation/TopNavigation';
import Navigation from '../../sections/Navigation/Navigation';
import FooterSection from '../../sections/Footer/Footer';
import { topNavItems, footerLinks, navigationConfigs } from '../../config/siteConfig';

interface PageLayoutProps {
  navType: 'business' | 'customer' | 'about';
  children: React.ReactNode;
}

/**
 * PageLayout component wraps all pages with consistent navigation and footer.
 * Eliminates duplicate layout code across all page components.
 */
export const PageLayout: React.FC<PageLayoutProps> = ({ navType, children }) => {
  const navItems = navigationConfigs[navType];

  return (
    <div>
      <TopNavigation items={topNavItems} />
      <Navigation items={navItems} topNavItems={topNavItems} />
      {children}
      <FooterSection links={footerLinks} />
    </div>
  );
};
